module.exports = __webpack_public_path__ + "static/media/agentic_engineering_talk.e45cba88.png";